/** @module Enums */ /** typedoc */
/**
 * Eligibility status for the Monetization Eligibility (aka Youtube Content Id) As Monetization is not eligible by default.
 * `Requested` Was undefined and/or user requested it when submitting the release.
 * `NotRequested` Was not requested when the release was submitted to support. (currently a support button allow to change it to requested later on)
 * `Eligible` Was flagged as eligible by support when Approving / Rejecting the release (only if state was `Requested`)
 * `Rejected` Was flagged as rejected by support when Approving / Rejecting the release (only if state was `Requested`)
 */
var MonetizationEligibilityStateEnum;
(function (MonetizationEligibilityStateEnum) {
    MonetizationEligibilityStateEnum["Requested"] = "Requested";
    MonetizationEligibilityStateEnum["NotRequested"] = "NotRequested";
    MonetizationEligibilityStateEnum["Eligible"] = "Eligible";
    MonetizationEligibilityStateEnum["Ineligible"] = "Ineligible";
    MonetizationEligibilityStateEnum["Rejected"] = "Rejected";
})(MonetizationEligibilityStateEnum || (MonetizationEligibilityStateEnum = {}));

export { MonetizationEligibilityStateEnum };
